import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-thankyou-screen',
  templateUrl: './thankyou-screen.component.html',
  styleUrls: ['./thankyou-screen.component.scss'],
})
export class ThankyouScreenComponent implements OnInit {

  constructor(private router: Router, private storage: Storage) { }

  ngOnInit() {}

  goToHomeScreen(){
    this.storage.clear();
    localStorage.clear();
    this.router.navigate(['/login']);
  }

}
